import React from 'react';
import styled from 'styled-components';
import ProductBody from './productBody/ProductBody';

const Wrapper = styled.div``;

function Product() {
  return (
    <Wrapper>
      <ProductBody />
    </Wrapper>
  );
}

export default Product;
